module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.e9ac7b9.woff2";